// schema
import * as ISchema from "@schema";
import { ReactNode } from "react";
import { RelayRefetchProp } from "react-relay";

import { IReduxState } from "@reducers/root.reducer";
import { setActiveViewEvent } from "@actions/chrome-extension.actions";
import { snackBarOpen } from "@actions/snack-bar.actions";

import { styles } from "./ChromeAutopilotList.styles";
import { WithStyles } from "@material-ui/core/styles/withStyles";

export enum AutopilotListMode {
  Card = "Card",
  Menu = "Menu",
}

export interface IRendererContainer {
  orgId: string;
  calendarId: string;
  environment: any; // types for QueryRenderer are busted — can take classic or modern environment but is demanding modern
  onClick?: (externalEventId: string, calendarId: string) => void;
  onLoad?: (firstExternalEventId?: ISchema.IEvent) => void;
  type?: AutopilotListMode;
  showHistory?: boolean;
  selectedExternalEventId?: string;
}

export interface IRendererProps extends IRendererContainer, WithStyles<typeof styles> {}

export interface IContainer {
  org: ISchema.IOrg;
  orgRefetch: ISchema.IOrg;
  onClick?: (externalEventId: string, calendarId: string) => void;
  onLoad?: (firstExternalEventId?: ISchema.IEvent) => void;
  selectedExternalEventId?: string;
  calendarId: string;
}

export interface IProps extends IContainer, WithStyles<typeof styles> {
  relay: RelayRefetchProp;
  setActiveViewEvent: typeof setActiveViewEvent;
  snackBarOpen: typeof snackBarOpen;
  mode: AutopilotListMode;
  showHistory: boolean;
}

export interface IState {
  autopilotEventsResponse: ISchema.IAutopilotEventsResponse | null;
  personMap: { [email: string]: ISchema.IPerson };
  suggestedAutopilot: ISchema.IEvent[];
  suggestedInvite: ISchema.IEvent[];
  dialogOpen: boolean;
}
